/**
 * Number Schema Types
 */

export type SchemaType = 'invoice' | 'customer' | 'offer' | 'delivery'
export type CounterReset = 'never' | 'yearly' | 'monthly' | 'daily' | 'per_customer'

export interface NumberSchema {
  id: string
  userId: string
  schemaType: SchemaType
  name: string
  description?: string
  template: string
  counterStart: number
  counterCurrent: number
  counterReset: CounterReset
  validFrom: string
  validUntil?: string
  isDefault: boolean
  customerId?: string
  isActive: boolean
  isSystemGenerated: boolean
  isUsed?: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateNumberSchemaData {
  schemaType: SchemaType
  name: string
  description?: string
  template: string
  counterStart?: number
  counterReset?: CounterReset
  validFrom?: string
  validUntil?: string
  isDefault?: boolean
  customerId?: string
  isActive?: boolean
}

export interface UpdateNumberSchemaData {
  name?: string
  description?: string
  template?: string
  counterStart?: number
  counterReset?: CounterReset
  validFrom?: string
  validUntil?: string
  isDefault?: boolean
  isActive?: boolean
}

export interface TemplatePlaceholder {
  key: string
  description: string
  example: string
  category: 'number' | 'date' | 'customer' | 'user' | 'other'
}

export const TEMPLATE_PLACEHOLDERS: TemplatePlaceholder[] = [
  {
    key: '{{NUMBER:5}}',
    description: 'Fortlaufende Nummer mit 5 Stellen (mit führenden Nullen)',
    example: '00042',
    category: 'number',
  },
  {
    key: '{{NUMBER}}',
    description: 'Fortlaufende Nummer ohne führende Nullen',
    example: '42',
    category: 'number',
  },
  {
    key: '{{YEAR}}',
    description: '4-stelliges Jahr',
    example: '2025',
    category: 'date',
  },
  {
    key: '{{YEAR:2}}',
    description: '2-stelliges Jahr',
    example: '25',
    category: 'date',
  },
  {
    key: '{{MONTH}}',
    description: '2-stelliger Monat',
    example: '03',
    category: 'date',
  },
  {
    key: '{{MONTH:1}}',
    description: '1-stelliger Monat',
    example: '3',
    category: 'date',
  },
  {
    key: '{{DAY}}',
    description: '2-stelliger Tag',
    example: '15',
    category: 'date',
  },
  {
    key: '{{RANDOM:4}}',
    description: 'Zufällige Ziffern (4 Stellen)',
    example: '7392',
    category: 'other',
  },
]

export const SCHEMA_TYPE_LABELS: Record<SchemaType, string> = {
  invoice: 'Rechnung',
  customer: 'Kunde',
  offer: 'Angebot',
  delivery: 'Lieferschein',
}

export const COUNTER_RESET_LABELS: Record<CounterReset, string> = {
  never: 'Niemals (durchgehend)',
  yearly: 'Jährlich',
  monthly: 'Monatlich',
  daily: 'Täglich',
  per_customer: 'Pro Kunde',
}
